import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Props = {};

const RevenueDetails = (props: Props) => {
  const navigate = useNavigate();
  const location: any = useLocation();
  const [revenues, setRevenues] = useState([location?.state?.revenueDetail]);

  return (
    <div>
      {revenues &&
        revenues.map((revenue: any, index: any) => {
          return (
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <p
                  style={{
                    fontSize: '30px',
                    fontWeight: '10px',
                    marginBottom: '20px',
                  }}
                >
                  Parking! {revenue.name}
                </p>
                <button
                  onClick={() => {
                    navigate('/dashboard/admin-revenue');
                  }}
                  style={{
                    width: '150px',
                    height: '40px',
                    marginRight: '10px',
                    background: 'blue',
                    border: 'none',
                    fontSize: '20px',
                    color: 'white',
                    borderRadius: '6px',
                    fontWeight: '100px',
                  }}
                >
                  Back
                </button>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                }}
              >
                {revenue.parkingSpaceRevenueDataList.map((list: any, index: any) => {
                  return (
                    <div
                      style={{
                        width: '290px',
                        height: '150px',
                        background: 'white',
                        marginBottom: '20px',
                        marginLeft: '20px',
                        boxShadow: '1px 2px 4px',
                        padding: '10px',
                        borderRadius: '8px',
                      }}
                    >
                      <div>
                        <div>
                          <p
                            style={{
                              fontSize: '20px',
                              color: 'black',
                              fontWeight: '60px',
                              marginBottom: '50px',
                            }}
                          >
                            {list.name}
                          </p>
                        </div>
                        <div
                          style={{
                            marginTop: '10px',
                          }}
                        >
                          <p
                            style={{
                              fontSize: '25px',
                              color: 'rgb(148 163 184)',
                              fontWeight: '700px',
                              marginBottom: '10px',
                            }}
                          >
                            ₹ {list.totalRevenue.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default RevenueDetails;
